import { ANNOUNCEMENT_TEXT } from "../../data/siteData";
import "./TopBanner.css";

function TopBanner() {
  return (
    <div className="top-banner" role="marquee" aria-label="Announcement">
      <div className="top-banner__track">
        <span className="top-banner__text">{ANNOUNCEMENT_TEXT}</span>
        <span className="top-banner__text">{ANNOUNCEMENT_TEXT}</span>
      </div>
    </div>
  );
}

export default TopBanner;